import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { NotificationManager } from "react-notifications";

import { Accordion } from "react-bootstrap";
import UnionIcon from "../../../assets/images/icons/Union_5.svg";
import AppsStudBuilderService from "../../../services/apps-studbuilder.service";
import { useTranslation } from "react-i18next";
import { Button, Spin, Switch, Tooltip } from "antd";
import appsDiamondlinksService from "../../../services/apps-diamondlinks.service";

const initialOptionsData = {
  studbuilderLinkURL: "",
  internalUseLink: false,
  showOnlyDiamondSearch: false,
  showDealerDiamondsSKU: false,
  showScheduleViewing: false,
  showAddress: false,
  showVendorSKU: true,
  showCallForPrice: false,
  applyGstTax: false,
  gstTaxValue: "",
  showPinterestShare: false,
  showTwitterShare: false,
  showFacebookShare: false,
  showFacebookLike: false,
  showAddToCartButton: false,
  ShoppingCartURL: "",
  showViewCartButton: false,
  ShowInstagramPlus: false,
  isShowEcommerce: true,
  showDiamondPrices: true,
  showLabGrownDiamondPrices: true,
};

const initialState = {
  dealerId: null,
  posSystem: null,
  appActivationControl: {},
};

export const StudBuilderOptions = (props) => {
  const { t } = useTranslation();
  const [myOptionsData, setMyOptionsData] = useState(initialOptionsData);
  const [dealerId, setDealerId] = useState();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [btnVisible, setBtnVisible] = useState(true);
  const [state, setState] = useState(initialState);
  const loginDetials = useSelector((state) => state.loginReducer);
  const [posSystemList, setPosSystemList] = useState([]);
  const [diamondLinkOptionData, setDiamondLinkOptionData] = useState({
    showDiamondPrices: true,
    showLabGrownDiamondPrices: true,
  });

  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetOptionsDetails(
            loginDetials.loginDetials.responseData.dealerId
          );
          handleGetOptionsDiamondDetails(
            loginDetials.loginDetials.responseData.dealerId
          );
        }
      }
    }
  }, []);

  const handleOnChange = (e, isSelect, name) => {
    if (name == "gstTaxValue") {
      const rx_live = /^[+-]?\d*(?:[.,]\d*)?$/;
      if (!rx_live.test(e.target.value)) {
        return false;
      }
    }

    if (isSelect === "select") {
      setBtnVisible(false);
      setMyOptionsData({
        ...myOptionsData,
        [name]: e,
      });
    } else {
      setBtnVisible(false);
      setMyOptionsData({
        ...myOptionsData,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleGetOptionsDetails = (id) => {
    let inputData = {
      dealerID: id,
    };
    setLoading(true);
    try {
      AppsStudBuilderService.GetStudOptionsDetails(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData[0];
          if (message === "Success") {
            if (responseData) {
              if (response.data.responseData.length > 0) {
                setMyOptionsData((prevState) => ({
                  ...prevState,
                  studbuilderLinkURL: responseData.studBuilderURL,
                  internalUseLink: responseData.internalLinkSB,
                  showOnlyDiamondSearch: responseData.onlyDiamondSearch,
                  showDealerDiamondsSKU: responseData.stud_ShowSKU,
                  showScheduleViewing: responseData.showScheduleView,
                  showAddress: responseData.showAddresses,
                  showVendorSKU: responseData.showVendorSKU,
                  showCallForPrice: responseData.callForPricestud,
                  applyGstTax: responseData.showGstPrice,
                  gstTaxValue:
                    responseData.taxRate == 0 ? "0" : responseData.taxRate,
                  showPinterestShare: responseData.showPinterestShare,
                  showTwitterShare: responseData.showTwitterShare,
                  showFacebookShare: responseData.showFacebookShare,
                  showFacebookLike: responseData.showFacebookLike,
                  showAddToCartButton: responseData.showAddToCartButtonStud,
                  ShoppingCartURL: responseData.diamondstudshoppingurl,
                  showViewCartButton: responseData.showViewCartButtonStud,
                  ShowInstagramPlus: responseData.showInstagramShare,
                  isShowEcommerce: responseData.isShowEcommerce,
                }));
              }
            }
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleSubmit = () => {
    try {
      setSubmitLoading(true);
      let inputData = {
        dealerID: dealerId,
        type: "StudBuilder",
        studBuilderURL: myOptionsData.studbuilderLinkURL,
        internalLinkSB: myOptionsData.internalUseLink,
        onlyDiamondSearch: myOptionsData.showOnlyDiamondSearch,
        cStud_ShowSKU: myOptionsData.showDealerDiamondsSKU,
        showScheduleView: myOptionsData.showScheduleViewing,
        showAddresses: myOptionsData.showAddress,
        showVendorSKU: myOptionsData.showVendorSKU,
        callForPricestud: myOptionsData.showCallForPrice,
        showGstPrice: myOptionsData.applyGstTax,
        taxRate: myOptionsData.gstTaxValue ? myOptionsData.gstTaxValue : "0",
        showPinterestShare: myOptionsData.showPinterestShare,
        showTwitterShare: myOptionsData.showTwitterShare,
        showFacebookShare: myOptionsData.showFacebookShare,
        showFacebookLike: myOptionsData.showFacebookLike,
        showAddToCartButtonStud: myOptionsData.showAddToCartButton,
        diamondstudshoppingurl: myOptionsData.ShoppingCartURL,
        showViewCartButtonStud: myOptionsData.showViewCartButton,
        showInstagramShare: myOptionsData.ShowInstagramPlus,
      };
      setLoading(true);
      AppsStudBuilderService.UpdateStudOptionsDetails(inputData)
        .then((response) => {
          let message = response.data.message;

          setLoading(false);
          setSubmitLoading(false);
          if (message === "Success") {
            handleDiamondSubmit();
          } else {
            NotificationManager.error(t("Data not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setSubmitLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSubmitLoading(false);
    }
    setBtnVisible(true);
  };

  const handleDiamondSubmit = () => {
    try {
      setSubmitLoading(true);
      let inputData = {
        dealerID: dealerId,
        type: "DiamondLink",
        diamondLinkURL: diamondLinkOptionData.diamondLinkURL,
        internalLinkDL: diamondLinkOptionData.internalUseLink,
        allowNewDiamondDealers: diamondLinkOptionData.acceptNewDiamondDealers,
        searchSortName: diamondLinkOptionData.sortSearchResultsInitiallyBy,
        searchSortOrder: diamondLinkOptionData.orderSearchResultsInitiallyBy,
        showInhouseDiamonds: diamondLinkOptionData.showInHouseDiamondsSKU,
        showInhouseFirst: diamondLinkOptionData.showInHouseDiamondsFirst,
        displayVendorSku: diamondLinkOptionData.displayVendorSKU,
        showDiamondFilter: diamondLinkOptionData.showDiamondFilter,
        showGIAreportchecklink: diamondLinkOptionData.showGIAReportCheckLink,
        showAdvanceOptionInDiamondSearch:
          diamondLinkOptionData.showAdvanceOptionsAsDefault,
        showCertificateDiamondSearch:
          diamondLinkOptionData.showCertificateInDiamondSearch,
        showEGLVariants: diamondLinkOptionData.showEGLCertificateVariants,
        requestCer: diamondLinkOptionData.showRequestCertificate,
        disableCertificate: diamondLinkOptionData.disableCertificateLinks,
        showcoloritemsoutofrange:
          diamondLinkOptionData.showColorItemsOutOfRange,
        showclarityitemsoutofrange:
          diamondLinkOptionData.showClarityItemsOutOfRange,
        acceptTotalPrice: diamondLinkOptionData.acceptTotalPriceForDiamond,
        isScheduleViewing: diamondLinkOptionData.scheduleViewing,
        dropaHint: diamondLinkOptionData.dropAHint,
        emailAFriend: diamondLinkOptionData.emailAFriend,
        showOriginDiamondSearch:
          diamondLinkOptionData.showOriginOnDiamondSearch,
        showCommentsOnDetailPage:
          diamondLinkOptionData.showVendorCommentsOnDetailsPage,
        showContact: diamondLinkOptionData.showContactNumber,
        showAddresses: diamondLinkOptionData.showAddresses,
        searchPageDetailLinkURL:
          diamondLinkOptionData.alternateDiamondDetailsLinkURL,
        useCustomDetailURL: diamondLinkOptionData.customDetailURL,
        showDiamondPricesOnPage: diamondLinkOptionData.showDiamondPrices,
        showPricesOnSearchPageFancy:
          diamondLinkOptionData.showFancyColorDiamondPrices,
        showPricesOnSearchPageLab:
          diamondLinkOptionData.showLabGrownDiamondPrices,
        markupOwnInventory: diamondLinkOptionData.markupYourOwnInventory,
        showPricePerCarat: diamondLinkOptionData.showPricePerCarat,
        showGstPrice: diamondLinkOptionData.applyGstTax,
        taxRate: diamondLinkOptionData.gstTaxValue,
        showPinterestShare: diamondLinkOptionData.showPinterestShare,
        showTwitterShare: diamondLinkOptionData.showTwitterShare,
        showFacebookShare: diamondLinkOptionData.showFacebookShare,
        showFacebookLike: diamondLinkOptionData.showFacebookLike,
        showInstagramShare: diamondLinkOptionData.showInstagramShare,
        ShowGooglePlus: diamondLinkOptionData.ShowGooglePlus,
        showAddToCartButton: diamondLinkOptionData.ctaButton
          ? diamondLinkOptionData.myOptionRadio == "addToCartBtn"
            ? 1
            : diamondLinkOptionData.myOptionRadio == "scheduleAViewing"
            ? 2
            : diamondLinkOptionData.myOptionRadio == "requestMoreInfo"
            ? 0
            : 3
          : 3,
        alternateShoppingCartURL:
          diamondLinkOptionData.alternateShoppingCartURL,
        showViewCartButton: diamondLinkOptionData.showViewCartButton,
        showAddToCartButtonOnSearchPage:
          diamondLinkOptionData.showAddToCartButton,
      };
      setLoading(true);
      appsDiamondlinksService
        .UpdateDiamondLinkOptionDetailsUpload(inputData)
        .then((response) => {
          let message = response.data.message;

          setLoading(false);
          setSubmitLoading(false);
          if (message === "Success") {
            NotificationManager.success(t("Data Updated Successfully."));
            handleGetOptionsDiamondDetails(dealerId);
            handleGetOptionsDetails(dealerId);
          } else {
            NotificationManager.error(t("Data not Updated."));
          }
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
          setSubmitLoading(false);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSubmitLoading(false);
    }
    setBtnVisible(true);
  };

  const handleGetOptionsDiamondDetails = (id) => {
    let inputData = {
      dealerID: id,
      type: "DiamondLink",
    };
    setLoading(true);
    try {
      appsDiamondlinksService
        .GetOptionsDetails(inputData)
        .then((response) => {
          setLoading(false);

          let message = response.data.message;
          let responseData = response.data.responseData[0];
          if (message === "Success") {
            if (responseData) {
              setDiamondLinkOptionData((prevState) => ({
                ...prevState,
                diamondLinkURL: responseData.diamondLinkURL,
                internalUseLink: responseData.internalLinkDL,
                acceptNewDiamondDealers: responseData.allowNewDiamondDealers,
                sortSearchResultsInitiallyBy: responseData.searchSortName,
                orderSearchResultsInitiallyBy: responseData.searchSortOrder,
                showInHouseDiamondsSKU: responseData.showInhouseDiamonds,
                displayVendorSKU: responseData.displayVendorSku,
                showDiamondFilter: responseData.showDiamondFilter,
                showInHouseDiamondsFirst: responseData.showInhouseFirst,
                showGIAReportCheckLink: responseData.showGIAreportchecklink,
                showAdvanceOptionsAsDefault:
                  responseData.showAdvanceDiamondSearch,
                showCertificateInDiamondSearch:
                  responseData.showCertificateDiamondSearch,
                showEGLCertificateVariants: responseData.showEGLVariants,
                showRequestCertificate: responseData.requestCer,
                disableCertificateLinks: responseData.disableCertificate,
                showColorItemsOutOfRange: responseData.showcoloritemsoutofrange,
                showClarityItemsOutOfRange:
                  responseData.showclarityitemsoutofrange,
                acceptTotalPriceForDiamond: responseData.acceptTotalPrice,
                scheduleViewing: responseData.isScheduleViewing,
                dropAHint: responseData.dropaHint,
                emailAFriend: responseData.emailAFriend,
                showOriginOnDiamondSearch: responseData.showOriginDiamondSearch,
                showVendorCommentsOnDetailsPage:
                  responseData.showCommentsOnDetailPage,
                showContactNumber: responseData.showContact,
                showAddresses: responseData.showAddresses,
                alternateDiamondDetailsLinkURL:
                  responseData.searchPageDetailLinkURL,
                customDetailURL: responseData.useCustomDetailURL,
                showDiamondPrices: responseData.showPricesOnSearchPage,
                showFancyColorDiamondPrices:
                  responseData.showPricesOnSearchPageFancy,
                showLabGrownDiamondPrices:
                  responseData.showPricesOnSearchPageLab,
                markupYourOwnInventory: responseData.markupOwnInventory,
                showPricePerCarat: responseData.showPricePerCarat,
                applyGstTax: responseData.showGstPrice,
                gstTaxValue: responseData.taxRate,
                showPinterestShare: responseData.showPinterestShare,
                showTwitterShare: responseData.showTwitterShare,
                showFacebookShare: responseData.showFacebookShare,
                showFacebookLike: responseData.showFacebookLike,
                showInstagramShare: responseData.showInstagramShare,
                ShowGooglePlus: responseData.showGooglePlus,
                ctaButton:
                  responseData.showAddToCartButton == 1
                    ? true
                    : responseData.showAddToCartButton == 2
                    ? true
                    : responseData.showAddToCartButton == 0
                    ? true
                    : responseData.showAddToCartButton == 3
                    ? false
                    : null,
                alternateShoppingCartURL: responseData.alternateShoppingCartURL,
                myOptionRadio:
                  responseData.showAddToCartButton == 1
                    ? "addToCartBtn"
                    : responseData.showAddToCartButton == 2
                    ? "scheduleAViewing"
                    : responseData.showAddToCartButton == 0
                    ? "requestMoreInfo"
                    : null,
                showViewCartButton: responseData.showViewCartButton,
                showAddToCartButton:
                  responseData.showAddToCartButtonOnSearchPage,
                isShowEcommerce: responseData.isShowEcommerce,
              }));
            }
          } else {
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleOnDiamondLinkChange = (e, isSelect, name) => {
    setBtnVisible(false);
    if (isSelect === "select") {
      setDiamondLinkOptionData({
        ...diamondLinkOptionData,
        [name]: e,
      });
    } else {
      setDiamondLinkOptionData({
        ...diamondLinkOptionData,
        [e.target.name]: e.target.value,
      });
    }
  };

  return (
    <div className="form__fields markup__section">
      <div className="row ">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 className="workarea__heading mt-0 mb-3"> {t("Options")} </h4>
          </div>
        </div>
      </div>

      <div className="row ">
        <Spin spinning={loading}>
          <div className="col-md-12">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div>
                    <label> {t("Setup")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Stud Builder URL")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Enter the URL of this tool on your site to enable social sharing and dynamic sizing."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          name="studbuilderLinkURL"
                          value={myOptionsData.studbuilderLinkURL}
                          onChange={(e) =>
                            handleOnChange(e, "", "studbuilderLinkURL")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Internal Use Link?")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the “For Internal Use Only” link at the bottom of the Item Details page, which will allow you to look up the vendor’s stock # and contact info for the viewed diamond pair."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="internalUseLink"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.internalUseLink}
                          onChange={(e) =>
                            handleOnChange(e, "select", "internalUseLink")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div>
                    <label htmlFor="h1"> {t("Display")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show")} "{t("Only Diamond Search")}"
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to ONLY display the Diamond Search portion of Stud Builder which pairs together diamonds of similar attributes."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showOnlyDiamondSearch"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showOnlyDiamondSearch}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showOnlyDiamondSearch")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Dealer SKU In Diamond Search")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Dealer/Vendor Stock # instead of the default unique GemFind SKU# (Ex. SKU# 108545370)."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showDealerDiamondsSKU"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showDealerDiamondsSKU}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showDealerDiamondsSKU")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Schedule Viewing")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the link which allows the customer the ability to schedule an appointment."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showScheduleViewing"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showScheduleViewing}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showScheduleViewing")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Addresses")}
                          <Tooltip
                            placement="right"
                            title={t("Allow address to show on detailpage.")}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showAddress"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showAddress}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showAddress")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Display Vendor SKU")}
                          <Tooltip
                            placement="right"
                            title={t("Display Vendor SKU")}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showVendorSKU"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showVendorSKU}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showVendorSKU")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <div>
                    <label> {t("Price")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Setting Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display “Call for Price” instead of the retail price or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showCallForPrice"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showCallForPrice}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showCallForPrice")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Mined Diamond Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "You may choose not to show mined diamond prices in search results if desired. Price range field in search form is not displayed when prices are not displayed."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showDiamondPrices"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          defaultChecked
                          checked={diamondLinkOptionData.showDiamondPrices}
                          onChange={(e) =>
                            handleOnDiamondLinkChange(
                              e,
                              "select",
                              "showDiamondPrices"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Lab Grown Diamond Price")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "You may choose not to show lab grown diamond prices in search results if desired. Price range field in search form is not displayed when prices are not displayed."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showLabGrownDiamondPrices"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          defaultChecked
                          checked={
                            diamondLinkOptionData.showLabGrownDiamondPrices
                          }
                          onChange={(e) =>
                            handleOnDiamondLinkChange(
                              e,
                              "select",
                              "showLabGrownDiamondPrices"
                            )
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Apply GST Tax")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Toggle the ability to apply international tax."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="applyGstTax"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.applyGstTax}
                          onChange={(e) =>
                            handleOnChange(e, "select", "applyGstTax")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("GST Tax Value")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Set the value when applying the GST Tax option."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          maxLength="2"
                          name="gstTaxValue"
                          value={
                            myOptionsData.gstTaxValue
                              ? myOptionsData.gstTaxValue
                              : ""
                          }
                          onChange={(e) => handleOnChange(e, "", "gstTaxValue")}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  <div>
                    <label> {t("Social")} </label>
                  </div>
                </Accordion.Header>
                <Accordion.Body>
                  <div className="row">

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Instagram Share")}
                          <Tooltip
                            placement="right"
                            title={
                              t("Choose whether to display the Instagram “Share” button or not.")
                            }
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="ShowInstagramPlus"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.ShowInstagramPlus}
                          onChange={(e) =>
                            handleOnChange(e, "select", "ShowInstagramPlus")
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Pinterest Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Pinterest “Pin it” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showPinterestShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showPinterestShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showPinterestShare")
                          }
                        />
                      </div>
                    </div> */}

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Twitter Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Twitter “Tweet” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showTwitterShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showTwitterShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showTwitterShare")
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Facebook Share")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Facebook “Share” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showFacebookShare"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showFacebookShare}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showFacebookShare")
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-4">
                      <div className="input__block">
                        <label>
                          {t("Show Facebook Like")}
                          <Tooltip
                            placement="right"
                            title={t(
                              "Choose whether to display the Facebook “Like” button or not."
                            )}
                          >
                            <img src={UnionIcon} alt="" />
                          </Tooltip>
                        </label>
                        <Switch
                          name="showFacebookLike"
                          checkedChildren={t("Yes")}
                          unCheckedChildren={t("No")}
                          checked={myOptionsData.showFacebookLike}
                          onChange={(e) =>
                            handleOnChange(e, "select", "showFacebookLike")
                          }
                        />
                      </div>
                    </div> */}

                  </div>
                </Accordion.Body>
              </Accordion.Item>
              {myOptionsData?.isShowEcommerce && (
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    <div>
                      <label> {t("E-Commerce")} </label>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Shopping Cart Url")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Change this value to alter the actual hyperlink to the shopping cart. This could be changed to link to your own shopping cart page. Additional diamond detail parameters are passed in the URL when this value is present. Leave blank for default value."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <input
                            type="text"
                            name="ShoppingCartURL"
                            value={myOptionsData.ShoppingCartURL}
                            onChange={(e) =>
                              handleOnChange(e, "", "ShoppingCartURL")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Show Add To Cart Button")}
                            <Tooltip
                              placement="right"
                              title={t(
                                "Choose whether to display the “Add to Cart” button or not."
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Switch
                            name="showAddToCartButton"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={myOptionsData.showAddToCartButton}
                            onChange={(e) =>
                              handleOnChange(e, "select", "showAddToCartButton")
                            }
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="input__block">
                          <label>
                            {t("Show")} "{t("View Cart")}" {t("Button")}
                            <Tooltip
                              placement="right"
                              title={t(
                                `Choose whether to display the PayPal Shopping Cart's "View Cart" Button or not.`
                              )}
                            >
                              <img src={UnionIcon} alt="" />
                            </Tooltip>
                          </label>
                          <Switch
                            name="showViewCartButton"
                            checkedChildren={t("Yes")}
                            unCheckedChildren={t("No")}
                            checked={myOptionsData.showViewCartButton}
                            onChange={(e) =>
                              handleOnChange(e, "select", "showViewCartButton")
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              )}
            </Accordion>
            <div className="row">
              <div className="col-md-12 mt-4">
                <Button
                  className={btnVisible ? "disabled-btn " : "primary-btn"}
                  disabled={btnVisible}
                  loading={submitLoading}
                  onClick={handleSubmit}
                >
                  {t("Update Settings")}
                </Button>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(StudBuilderOptions);
